// import {apiAction} from './helper';

export const SET_EXTRA_VAR_TEMP_VALUE = 'SET_EXTRA_VAR_TEMP_VALUE';
export const INIT_EXTRA_VARS = 'INIT_EXTRA_VARS';
export const SAVE_EXTRA_VAR_VALUE = 'SAVE_EXTRA_VAR_VALUE';
export const SET_EXTRA_VAR_IS_EDITING = 'SET_EXTRA_VAR_IS_EDITING';
export const CREATE_EXTRA_LAMP_VARS = 'CREATE_EXTRA_LAMP_VARS';
